/**
 * @file Content header wrapper.
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node, // Add support for contextual string
    PropTypes.string,
  ]),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  reverse: PropTypes.bool,
  className: PropTypes.string,
};

const ContentHeader = ({ title, children, reverse, className }) => {
  return (
    <div
      className={classNames({
        'content-header': true,
        'content-header-reverse': reverse,
        [className]: className,
      })}
    >
      {title && (
        <div className="content-header-main">
          <h3 className="content-header-title">{title}</h3>
        </div>
      )}

      {children && <div className="content-header-nav">{children}</div>}
    </div>
  );
};

ContentHeader.propTypes = propTypes;

export default ContentHeader;
